import { createContext, useEffect, useState } from "react"



const INITIAL_STATE = {
    userId: "",
    userName: "",
    productsList: "",
    fee: 60,
    totalProductsAmount: 0,
    totalProductsPrice: 0,
    status: "待確認訂單",
    buyingName: "",
    storecategories: "711店到店",
    storename: "",
    storeaddress: "",
    LineName: "",
    phoneNumber: "",
}


export const OrderContext = createContext({
    order: INITIAL_STATE,
    cleanOrder: () => {},
    setOrder: (event: {   }) => { },
    handleContextChange: (event:  { target: { name: any; value: any; }}) => { },
});

interface ContextProps {
    // value: ContextValue,
    children: JSX.Element | JSX.Element[]
}

export const OrderContextProvider = ({ children }: ContextProps) => {
    // const [state, dispatchOrder] = useReducer(OrderReducer, INITIAL_STATE)
    const [order, setOrder] = useState(JSON.parse(localStorage.getItem("order") as string) || INITIAL_STATE);
    // const [isClicked, setIsClicked] = useState(initialState);
    // const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: !isClicked.clicked });

    const handleContextChange = (e: { target: { name: any; value: any; }; }) => {
        setOrder((i: any) => ({ ...i, [e.target.name]: e.target.value }));

    }
    const cleanOrder = () => {
        setOrder(() => INITIAL_STATE);
    }
    useEffect(() => {
        localStorage.setItem("order", JSON.stringify(order))

    }, [order])

    return (
        <OrderContext.Provider
            value={{
                order,
                cleanOrder,
                setOrder,
                handleContextChange,
            }}>
            {children}
        </OrderContext.Provider>
    )
}

